/**
 * @generated SignedSource<<0e2747cccec2948271b02a7774947e45>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ClientDeleteMutation$variables = {
  id: number;
};
export type ClientDeleteMutation$data = {
  readonly deleteClient: {
    readonly account: {
      readonly clients: ReadonlyArray<{
        readonly id: number;
      }>;
      readonly id: number;
    } | null | undefined;
  };
};
export type ClientDeleteMutation = {
  response: ClientDeleteMutation$data;
  variables: ClientDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "DeleteClientResult",
    "kind": "LinkedField",
    "name": "deleteClient",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "accounts",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "clients",
            "kind": "LinkedField",
            "name": "clients",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientDeleteMutation",
    "selections": (v2/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClientDeleteMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "0f6b16f2fe3808187defcd400a3192ba",
    "id": null,
    "metadata": {},
    "name": "ClientDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation ClientDeleteMutation(\n  $id: Int!\n) {\n  deleteClient(id: $id) {\n    account {\n      id\n      clients {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0d13dde5be0c967db0415586881de7b6";

export default node;
